import React from "react";
import Button from "../../../components/common/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const   VehicleModel = ({ open, handleClose }) => {
  return (
    <>
      <Dialog
        maxWidth={"xs"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <Stack
          spacing={2}
          sx={{ justifyContent: "center", alignItems: "center", p: 4.5 }}
        >
          <img src="../images/Group 67505.png" alt="logo" />
          <Typography
            sx={{ fontSize: "18px", fontWeight: "600", textAlign: "center" }}
          >
            Vehicle Model <br></br> added successfully.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => handleClose()}
            children="Ok"
          />
        </Stack>
      </Dialog>
    </>
  );
};

export default VehicleModel;
